import axios from "axios";
import { notify } from "../../../util/notify";
import React, { useState, useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import { FaUser, FaEnvelope, FaLock, FaEye, FaEyeSlash } from "react-icons/fa";
import { applyStoreTitle } from "../../../util/storeLogoHelper";
import { isCustomerLoggedIn, nextPathAfterLogin, saveCustomerSession } from "../../../util/customerAuth";

export default function Register() {
  const history = useHistory();
  const [showPassword, setShowPassword] = useState(false);
  const [registerInput, setregisterInput] = useState({
    name: "",
    email: "",
    password: "",
    error_list: [],
  });
  const [loading, setloading] = useState(false);
  const [formMessage, setFormMessage] = useState("");

  useEffect(() => {
    window.scrollTo(0, 0);
    applyStoreTitle(null, "Create an Account");
    if (isCustomerLoggedIn()) {
      history.replace(nextPathAfterLogin(history.location.search));
    }
  }, [history]);

  const handleInput = (e) => {
    e.persist();
    setregisterInput({ ...registerInput, [e.target.name]: e.target.value });
  };

  const registerSubmit = (e) => {
    e.preventDefault();
    setloading(true);
    setFormMessage("");

    const data = {
      name: registerInput.name,
      email: registerInput.email,
      password: registerInput.password,
    };

    axios.get("/sanctum/csrf-cookie").then(() => {
      axios.post(`/api/register`, data).then((res) => {
        setloading(false);
        if (res.data.status === 200) {
          saveCustomerSession(res.data);
          setregisterInput({
            name: "",
            email: "",
            password: "",
            error_list: [],
          });
          notify(res.data.message || "Welcome! Your account is ready.");
          history.push(nextPathAfterLogin(history.location.search));
        } else {
          setregisterInput({
            ...registerInput,
            error_list: res.data.validation_errors || [],
          });
        }
      }).catch(() => {
        setloading(false);
        setFormMessage("Could not create the account. Check your connection and try again.");
      });
    }).catch(() => {
      setloading(false);
      setFormMessage("Could not reach the store. Check your connection and try again.");
    });
  };

  return (
    <div className="auth-container-modern">
      <div className="auth-card-modern">
        <div className="auth-header">
          <h3 className="fw-bold">Create an Account</h3>
          <p>Join thousands of shoppers enjoying exclusive discounts</p>
        </div>

        <form onSubmit={registerSubmit}>
          {formMessage && (
            <div className="alert alert-danger py-2 px-3 small" role="alert">{formMessage}</div>
          )}
          {/* Full Name */}
          <div className="mb-3">
            <label className="form-label fw-semibold" style={{ fontSize: "13.5px" }}>
              Full Name
            </label>
            <div className="input-group">
              <span className="input-group-text bg-light border-end-0">
                <FaUser color="var(--text-muted)" />
              </span>
              <input
                type="text"
                name="name"
                value={registerInput.name}
                onChange={handleInput}
                className={`form-control border-start-0 ${
                  registerInput.error_list?.name ? "is-invalid" : ""
                }`}
                placeholder="e.g. Bilal Ahmed"
                required
              />
            </div>
            {registerInput.error_list?.name && (
              <small className="text-danger">{registerInput.error_list.name}</small>
            )}
          </div>

          {/* Email */}
          <div className="mb-3">
            <label className="form-label fw-semibold" style={{ fontSize: "13.5px" }}>
              Email Address
            </label>
            <div className="input-group">
              <span className="input-group-text bg-light border-end-0">
                <FaEnvelope color="var(--text-muted)" />
              </span>
              <input
                type="email"
                name="email"
                value={registerInput.email}
                onChange={handleInput}
                className={`form-control border-start-0 ${
                  registerInput.error_list?.email ? "is-invalid" : ""
                }`}
                placeholder="name@example.com"
                required
              />
            </div>
            {registerInput.error_list?.email && (
              <small className="text-danger">{registerInput.error_list.email}</small>
            )}
          </div>

          {/* Password */}
          <div className="mb-4">
            <label className="form-label fw-semibold" style={{ fontSize: "13.5px" }}>
              Password
            </label>
            <div className="input-group">
              <span className="input-group-text bg-light border-end-0">
                <FaLock color="var(--text-muted)" />
              </span>
              <input
                type={showPassword ? "text" : "password"}
                name="password"
                value={registerInput.password}
                onChange={handleInput}
                className={`form-control border-start-0 border-end-0 ${
                  registerInput.error_list?.password ? "is-invalid" : ""
                }`}
                placeholder="Create a strong password"
                required
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="input-group-text bg-light border-start-0"
                style={{ cursor: "pointer" }}
              >
                {showPassword ? <FaEyeSlash size={14} /> : <FaEye size={14} />}
              </button>
            </div>
            {registerInput.error_list?.password && (
              <small className="text-danger">{registerInput.error_list.password}</small>
            )}
          </div>

          {/* Submit Button */}
          <button
            type="submit"
            className="btn btn-primary w-100 py-3 fw-bold rounded-pill"
            style={{ background: "var(--primary)", border: "none" }}
            disabled={loading}
          >
            {loading ? "Creating Account..." : "Create Account"}
          </button>
        </form>

        <div className="text-center mt-4 pt-3 border-top" style={{ fontSize: "14px" }}>
          <span className="text-muted">Already have an account? </span>
          <Link to={`/login${history.location.search || ""}`} className="fw-bold" style={{ color: "var(--accent)" }}>
            Sign in
          </Link>
        </div>
      </div>
    </div>
  );
}
